module.exports = __webpack_public_path__ + "media/images/rb_logo-06917fd805db45e3935c74de77e9d7ca.png";